import { useCallback } from 'react'

import { isFieldEditable } from 'features/views/attributes/editable/utils'
import { useRecordManagerContext } from 'features/views/RecordManager/useRecordManagerContext'

import { useRecordSupportsEditing } from './useRecordSupportsEditing'

export function useIsFieldEditable() {
    const { permissions } = useRecordManagerContext()

    const supportsEditing = useRecordSupportsEditing()

    return useCallback(
        (field: FieldDto) => {
            const fieldsWithWritePerms = new Set(permissions.canUpdateFields)

            return (
                supportsEditing &&
                isFieldEditable(field) &&
                fieldsWithWritePerms.has(field.api_name)
            )
        },
        [permissions.canUpdateFields, supportsEditing]
    )
}
